import { ReactComponent as BgrBean } from './../../images/svg/bgr-bean.svg';
import logo from '../../images/logo_advante.webp'

import ClientsList from '../../jsons/clients.json'
const clientsImages = require.context('../../images/logo-clients', true );

const Header = () => {
  return (
    <div className='about-all-section'>
      <section className="about-header">
        <div className='BgrBean BgrBean-01'>
            <BgrBean />
        </div>
        <div className='BgrBean BgrBean-02'>
            <BgrBean />
        </div>
        <div className="bgr-noise"></div>
        <div className="containerFull">

          <div className="about-headline">
            <h1>BEHIND <br /><span>THE</span> DELIVERY.</h1>
            <p className="about-headline-subtitle">How Advante Digital uses experience, AI-assisted engineering, and Motionode to deliver safer software changes.</p>
          </div>

        </div>
      </section>

      <section className="about-main">
        <div className='about-wave'>
          <svg viewBox="0 0 1920 140">
              <path/>
          </svg>
        </div>
        <div className='BgrBean BgrBean-201'>
            <BgrBean />
        </div>
        
        <div className='BgrBean BgrBean-202'>
            <BgrBean />
        </div>
      
        <div className='BgrBean BgrBean-203'>
            <BgrBean />
        </div>
    
        <div className='BgrBean BgrBean-204'>
            <BgrBean />
        </div>

        <div className="bgr-noise"></div>
        <div className="about-about containerFull">
          <div className='about-about-grid'>
            <div className='about-who'>
              <h3>Who <span>we</span>  are.</h3>
              <p>Advante Digital is a software delivery company focused on helping businesses maintain, modernize, and improve existing platforms.</p>
              <p>We work with companies that already depend on software — marketplaces, admin systems, mobile apps, portals, ecommerce platforms, payment flows, and internal tools — and help them move faster without losing control of quality, staging, deployment, or production stability.</p>
              <p>Our work is supported by Motionode, our internal AI-assisted delivery platform that connects tickets, engineering work, code changes, QA, and deployment into one controlled process.</p>
            </div>
            <div className='about-logo'>
              <img 
                src={logo} 
                alt="Logo Advante" 
              />
            </div>
            <div className='about-experience'>
              <h3><span>Our</span> Experience.</h3>
              <p>For more than 15 years, we have built, maintained, and supported software platforms across healthcare, marketplaces, staffing, ecommerce, payments, mobile apps, and business operations.</p>
              <p>That experience taught us that the hardest part of software is not just writing code. It is understanding the business rules, protecting production, communicating clearly, testing changes, and keeping delivery organized.</p>
              <p>Today, we combine that experience with AI-assisted engineering and Motionode so our team can move faster while keeping the controls that real software systems require.</p>
            </div>
          </div>
          <div className='about-motionode-note'>
            <h4>Powered by Motionode</h4>
            <p>Our internal platform for AI-assisted software delivery, human review, staging, QA, and controlled deployment.</p>
          </div>
        </div>
      </section>

      <section className="about-clients">

        <div className='BgrBean BgrBean-301'>
            <BgrBean />
        </div>
      
        <div className='BgrBean BgrBean-302'>
            <BgrBean />
        </div>

        <div className="bgr-noise"></div>

        <div className='about-clients-box containerFull'>
          <div className='about-clients-headline'>
            <h2>Long-term software partners, not one-off coders.</h2>
          </div>
          <div className='about-clients-copy'>
            <p>We work best with companies that need ongoing software improvement, not just a quick prototype. Many businesses already have a platform, users, payment flows, admin operations, integrations, or legacy code that cannot be treated casually.</p>
            <p>Our goal is to become the team that helps them keep moving: clearing backlog tickets, improving workflows, fixing production-sensitive issues, modernizing old systems, and supporting the product as the business changes.</p>
          </div>
        </div>

        
          <div className='clients-list-wrapper'>
            <div className='clients-list-track'>
              {
                ClientsList.map((client) => (
                  <div key={ client.id }>
                    <img 
                      src={clientsImages(`./${client.file}`)}
                      alt={client.name}
                    />
                  </div>
                ))
              }
            </div>
          </div>

      </section>
    </div>
  );
};

export default Header;
